import { jsx as e } from "react/jsx-runtime";
import { TextProvider as L } from "../../../context/Text.js";
import { useTypography as T, TypographyProvider as M } from "../../../context/Typography.js";
import { useGetLinkComponentAndProps as F } from "../../../hooks/link/index.js";
import { getToneContentColorRole as j } from "../../../styles/colors/content/getToneContentColorRole.js";
import { typographyBodySizeMap as A, typographyBodyLineHeightMap as G } from "../../../styles/typography/typography.js";
import I from "../utils/getLinkStyles.js";
import "styled-components";
import { useThemeInMode as R } from "../../../context/theme/hooks.js";
function V({
  children: p,
  to: m,
  onClick: t,
  newTab: r,
  disabled: o = !1,
  size: s,
  lineHeight: y,
  navLink: l,
  exact: h,
  replace: a,
  tone: g = "primary",
  emphasis: f = "high",
  onHighEmphasisSurface: c = !1,
  disableInteractiveStyles: d = !1,
  underline: u = !1,
  fontWeight: z = "bold",
  state: C
}) {
  const k = R()[j({
    tone: g,
    emphasis: f,
    onHighEmphasisSurface: c
  })], i = I(
    o,
    d,
    u,
    z
  ), { Component: v, linkProps: x } = F({
    to: m,
    disabled: o,
    newTab: r,
    navLink: l,
    styleProps: i,
    replace: a,
    state: C
  }), {
    typographyBodySize: B,
    lineHeight: H
  } = T(), n = s || B || "medium", P = y || H || "small";
  return /* @__PURE__ */ e(
    v,
    {
      target: r ? "_blank" : void 0,
      onClick: (S) => {
        !o && t && t(S);
      },
      ...A[n],
      ...G[P],
      exact: h,
      ...x,
      ...i,
      color: k,
      children: /* @__PURE__ */ e(L, { value: !0, children: /* @__PURE__ */ e(M, { value: { typographyBodySize: n }, children: p }) })
    }
  );
}
export {
  V as default
};
